import { useEffect, useState } from 'react';
import { publicConfigApi } from '../lib/api';

export type PublicConfigState = {
  frontendUrl: string;
  playStoreShowOfficialWebsiteUrl: boolean;
};

const DEFAULT_PUBLIC_CONFIG: PublicConfigState = {
  frontendUrl: '',
  playStoreShowOfficialWebsiteUrl: false,
};

export const usePublicConfig = (enabled = true): PublicConfigState => {
  const [config, setConfig] = useState<PublicConfigState>(DEFAULT_PUBLIC_CONFIG);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const loadConfig = async (): Promise<void> => {
      const res = await publicConfigApi.get();
      if (!res.success || !res.data) {
        return;
      }
      setConfig({
        frontendUrl: res.data.frontendUrl.replace(/\/$/, ''),
        playStoreShowOfficialWebsiteUrl: res.data.playStoreShowOfficialWebsiteUrl === true,
      });
    };
    void loadConfig();
  }, [enabled]);

  return config;
};
